var render = function () {
  var _this$query_search;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row brands"
  }, [_c('div', {
    staticClass: "w-full px-4"
  }, [_c('HeaderBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'Brands'
      }],
      "title": "All Brands"
    }
  }), _c('div', {
    staticClass: "bg-white p-0 my-3 rounded-lg shadow-sm"
  }, [_c('div', {
    staticClass: "flex justify-between items-center px-4 pt-3 align-middle mb-3"
  }, [_c('div', {
    staticClass: "block relative"
  }, [_c('svg', {
    staticClass: "w-6 h-6 text-gray-500 dark:text-white absolute top-1.5 left-3",
    attrs: {
      "aria-hidden": "true",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "fill": "none",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "2",
      "d": "m21 21-3.5-3.5M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
    }
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.query_search,
      expression: "query_search"
    }],
    staticClass: "bg-white rounded-lg py-2 px-11 border w-96",
    attrs: {
      "placeholder": "Search Brands Name, Code"
    },
    domProps: {
      "value": _vm.query_search
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.query_search = $event.target.value;
      }, _vm.onSearch]
    }
  }), (_this$query_search = this.query_search) !== null && _this$query_search !== void 0 && _this$query_search.length ? _c('button', {
    staticClass: "absolute top-1/2 right-5 transform -translate-y-1/2 text-gray-500 hover:text-gray-700",
    attrs: {
      "title": "Clear search"
    },
    on: {
      "click": _vm.refreshPage
    }
  }, [_vm._v(" ✕ ")]) : _vm._e()]), _c('button', {
    staticClass: "text-gray-500 mr-3 bg-blue-700 border focus:outline-none font-medium rounded-lg text-sm px-2 py-2.5 text-center",
    attrs: {
      "type": "button"
    }
  }, [_c('router-link', {
    staticClass: "text-white px-1 py-2",
    attrs: {
      "to": _vm.CreateBrandPath
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add New ")])], 1)]), _c('div', {
    staticClass: "w-full"
  }, [_c('Table', {
    attrs: {
      "headers": _vm.headers,
      "data": _vm.brands,
      "withScrollX": true,
      "isLoading": _vm.isLoading,
      "withAction": false,
      "row-key": ['name', 'brand_code', 'vendor_name', 'is_active', 'action_edit_brands', 'action_edit_premiums'],
      "current-page": _vm.currentPage,
      "per-page": 20
    },
    scopedSlots: _vm._u([{
      key: "name",
      fn: function (_ref) {
        var value = _ref.value;
        return [_c('div', {
          staticClass: "px-0 py-1 rounded-lg w-96 text-left capitalize",
          class: _vm.statusColor(value)
        }, [_vm._v(" " + _vm._s(value) + " ")])];
      }
    }, {
      key: "is_active",
      fn: function (_ref2) {
        var value = _ref2.value;
        return [_c('div', {
          staticClass: "px-0 w-16 py-1 rounded-lg text-xs text-center capitalize",
          class: _vm.statusColor(value)
        }, [value ? _c('p', {
          staticClass: "mb-0 px-0"
        }, [_vm._v(" Active ")]) : _c('p', {
          staticClass: "mb-0 px-0"
        }, [_vm._v(" Inactive ")])])];
      }
    }, {
      key: "action_edit_brands",
      fn: function (_ref3) {
        var row = _ref3.row;
        return [_c('router-link', {
          staticClass: "link text-gray-600 align-middle items-center flex justify-center mr-4",
          attrs: {
            "to": {
              path: '/brands/editBrands/' + row.id
            }
          }
        }, [_c('svg', {
          staticClass: "w-6 h-6 text-gray-600 dark:text-white",
          attrs: {
            "aria-hidden": "true",
            "xmlns": "http://www.w3.org/2000/svg",
            "width": "24",
            "height": "24",
            "fill": "currentColor",
            "viewBox": "0 0 24 24"
          }
        }, [_c('path', {
          attrs: {
            "fill-rule": "evenodd",
            "d": "M11.32 6.176H5c-1.105 0-2 .949-2 2.118v10.588C3 20.052 3.895 21 5 21h11c1.105 0 2-.948 2-2.118v-7.75l-3.914 4.144A2.46 2.46 0 0 1 12.81 16l-2.681.568c-1.75.37-3.292-1.263-2.942-3.115l.536-2.839c.097-.512.335-.983.684-1.352l2.914-3.086Z",
            "clip-rule": "evenodd"
          }
        }), _c('path', {
          attrs: {
            "fill-rule": "evenodd",
            "d": "M19.846 4.318a2.148 2.148 0 0 0-.437-.692 2.014 2.014 0 0 0-.654-.463 1.92 1.92 0 0 0-1.544 0 2.014 2.014 0 0 0-.654.463l-.546.578 2.852 3.02.546-.579a2.14 2.14 0 0 0 .437-.692 2.244 2.244 0 0 0 0-1.635ZM17.45 8.721 14.597 5.7 9.82 10.76a.54.54 0 0 0-.137.27l-.536 2.84c-.07.37.239.696.588.622l2.682-.567a.492.492 0 0 0 .255-.145l4.778-5.06Z",
            "clip-rule": "evenodd"
          }
        })])])];
      }
    }, {
      key: "action_edit_premiums",
      fn: function (_ref4) {
        var row = _ref4.row;
        return [_c('router-link', {
          staticClass: "link text-gray-600 align-middle items-center flex justify-center mr-5",
          attrs: {
            "to": {
              path: '/brands/displayPremiums/' + row.id
            }
          }
        }, [_c('svg', {
          staticClass: "w-6 h-6 text-gray-600 dark:text-white",
          attrs: {
            "aria-hidden": "true",
            "xmlns": "http://www.w3.org/2000/svg",
            "width": "24",
            "height": "24",
            "fill": "currentColor",
            "viewBox": "0 0 24 24"
          }
        }, [_c('path', {
          attrs: {
            "fill-rule": "evenodd",
            "d": "M11.32 6.176H5c-1.105 0-2 .949-2 2.118v10.588C3 20.052 3.895 21 5 21h11c1.105 0 2-.948 2-2.118v-7.75l-3.914 4.144A2.46 2.46 0 0 1 12.81 16l-2.681.568c-1.75.37-3.292-1.263-2.942-3.115l.536-2.839c.097-.512.335-.983.684-1.352l2.914-3.086Z",
            "clip-rule": "evenodd"
          }
        }), _c('path', {
          attrs: {
            "fill-rule": "evenodd",
            "d": "M19.846 4.318a2.148 2.148 0 0 0-.437-.692 2.014 2.014 0 0 0-.654-.463 1.92 1.92 0 0 0-1.544 0 2.014 2.014 0 0 0-.654.463l-.546.578 2.852 3.02.546-.579a2.14 2.14 0 0 0 .437-.692 2.244 2.244 0 0 0 0-1.635ZM17.45 8.721 14.597 5.7 9.82 10.76a.54.54 0 0 0-.137.27l-.536 2.84c-.07.37.239.696.588.622l2.682-.567a.492.492 0 0 0 .255-.145l4.778-5.06Z",
            "clip-rule": "evenodd"
          }
        })])])];
      }
    }])
  })], 1), _vm.totalRows / _vm.perPage > 1 ? _c('div', {
    staticClass: "flex justify-between ml-1 items-center mt-3 px-3"
  }, [_c('div', {
    staticClass: "font-semibold"
  }, [_c('span', {
    staticClass: "text-gray-500 font-normal"
  }, [_vm._v("Showing ")]), _vm._v(" " + _vm._s(_vm.currentPage) + "-" + _vm._s(_vm.perPage) + " "), _c('span', {
    staticClass: "text-gray-500 font-normal"
  }, [_vm._v("of")]), _vm._v(" " + _vm._s(parseInt(_vm.totalRows)) + " ")]), _c('div', {
    staticClass: "mb-2"
  }, [_c('t-pagination', {
    staticClass: "rounded-lg",
    attrs: {
      "total-items": Number(_vm.totalRows),
      "per-page": _vm.perPage
    },
    model: {
      value: _vm.currentPage,
      callback: function ($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)]) : _vm._e()])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }